/**
 * Run a promise from an event handler without leaving it unhandled. Mutations
 * already toast their errors, so a rejection needs no further handling here.
 */
export function fire(p: Promise<unknown>): void {
  p.catch(() => undefined)
}
